import React, {useState, useEffect} from 'react';
import {withRouter} from 'react-router-dom';
import {
    Button,
    DatePicker,
    message, Popconfirm,
    Space,
    Table,
    Upload,
    Input,
    Row,
    Col,
    Form
} from 'antd';
import PageContent from '../../components/page-content/page-content';
import Box from '../../components/box';
import {getAll, getDetail, postAdd, postRemove, updatefkrq} from "../../lib/api_cw_zcfkd";
import {UploadOutlined} from "@ant-design/icons";
import XLSX from "xlsx";
import moment, {isMoment} from "moment";
import ZcfkdEditModal from "./zcfkd_modal";


const {Column} = Table;


const Zcsj = (props) => {
    const [data, setData] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [loadingQYWX, setLoadingQYWX] = useState(false);
    const [loadingUpload, setLoadingUpload] = useState(false);
    const [detailModal, setDetailModal] = useState(null);
    // const [state, setState] = useUrlState({current: 1, pageSize: 10});
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });
    const [fkrq, setFkrq] = useState(null); // 付款日期
    
    // 搜索状态
    const [searchParams, setSearchParams] = useState({
        id: '',
        cjsj: null,
        fkrq: null,
        hjjeMin: '',
        hjjeMax: '',
        huhao: '',
        zhanghao: '',
        kaihuhang: ''
    });


    /**
     * 获取数据
     */
    const fetchData = () => {
        console.log(tableParams);
        getAll({
            page: tableParams.pagination.current,
            size: tableParams.pagination.pageSize,
            filters: tableParams.filters
        })
            .then((res) => {
                if (res.code === 0) {
                    setData(res.data.records);
                    setTableParams({
                        ...tableParams,
                        pagination: {
                            ...tableParams.pagination,
                            total: res.data.total,
                        }
                    })
                }
            })
    }
    useEffect(fetchData, [JSON.stringify(tableParams)]);


    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
            setSelectedRows(selectedRowKeys);
        },
    };


    const handleTableChange = (pagination, filters, sorter) => {
        console.log(pagination, filters, sorter);
        setTableParams({
            pagination,
            filters,
            ...sorter,
        });
    };

    const hasSelected = selectedRows.length > 0;


    // 设置付款日期
    const handleSetFKRQ = () => {
        console.log(selectedRows, fkrq);
        updatefkrq(selectedRows, fkrq).then((res) => {
            if (res.code === 0) {
                message.success(res.message);
                fetchData();
            }
        })
    }
    
    // 处理搜索
    const handleSearch = () => {
        // 格式化日期为YYYY-MM-DD格式
        const formattedSearchParams = {
            ...searchParams,
            cjsj: searchParams.cjsj ? moment(searchParams.cjsj).format('YYYY-MM-DD') : null,
            fkrq: searchParams.fkrq ? moment(searchParams.fkrq).format('YYYY-MM-DD') : null
        };
        
        // 重置当前页为第一页
        setTableParams({
            ...tableParams,
            pagination: {
                ...tableParams.pagination,
                current: 1
            },
            filters: formattedSearchParams
        });
    }
    
    // 重置搜索
    const handleReset = () => {
        setSearchParams({
            id: '',
            cjsj: null,
            fkrq: null,
            hjjeMin: '',
            hjjeMax: '',
            huhao: '',
            zhanghao: '',
            kaihuhang: ''
        });
        setTableParams({
            ...tableParams,
            pagination: {
                ...tableParams.pagination,
                current: 1
            },
            filters: {}
        });
    }

    return (
        <PageContent>
            <Box title={"支出数据"}>
                {/* 搜索表单 */}
                <div style={{ marginBottom: 16, padding: '16px', background: '#f5f5f5', borderRadius: '6px' }}>
                    <Form layout="inline">
                        {/* 第一行：编号、创建日期、付款日期 */}
                        <Row gutter={16} style={{ width: '100%', marginBottom: 16 }}>
                            <Col span={8}>
                                <Form.Item label="编号" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                    <Input 
                                        placeholder="请输入编号" 
                                        value={searchParams.id}
                                        onChange={(e) => setSearchParams({...searchParams, id: e.target.value})}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item label="创建日期" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                    <DatePicker 
                                        placeholder="请选择创建日期" 
                                        style={{width: '100%'}}
                                        value={searchParams.cjsj}
                                        onChange={(date) => setSearchParams({...searchParams, cjsj: date})}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item label="付款日期" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                    <DatePicker 
                                        placeholder="请选择付款日期" 
                                        style={{width: '100%'}}
                                        value={searchParams.fkrq}
                                        onChange={(date) => setSearchParams({...searchParams, fkrq: date})}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        
                        {/* 第二行：金额范围、户号、账号 */}
                        <Row gutter={16} style={{ width: '100%', marginBottom: 16 }}>
                            <Col span={8}>
                                <Form.Item label="金额范围" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                    <Input.Group compact>
                                        <Input 
                                            placeholder="最小金额" 
                                            style={{width: '50%'}}
                                            value={searchParams.hjjeMin}
                                            onChange={(e) => setSearchParams({...searchParams, hjjeMin: e.target.value})}
                                        />
                                        <Input 
                                            placeholder="最大金额" 
                                            style={{width: '50%'}}
                                            value={searchParams.hjjeMax}
                                            onChange={(e) => setSearchParams({...searchParams, hjjeMax: e.target.value})}
                                    />
                                    </Input.Group>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item label="户号" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                    <Input 
                                        placeholder="请输入户号" 
                                        value={searchParams.huhao}
                                        onChange={(e) => setSearchParams({...searchParams, huhao: e.target.value})}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item label="账号" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                    <Input 
                                        placeholder="请输入账号" 
                                        value={searchParams.zhanghao}
                                        onChange={(e) => setSearchParams({...searchParams, zhanghao: e.target.value})}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        
                        {/* 第三行：开户行、操作按钮 */}
                        <Row gutter={16} style={{ width: '100%' }}>
                            <Col span={8}>
                                <Form.Item label="开户行" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                    <Input 
                                        placeholder="请输入开户行" 
                                        value={searchParams.kaihuhang}
                                        onChange={(e) => setSearchParams({...searchParams, kaihuhang: e.target.value})}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                    <Space>
                                        <Button type="primary" onClick={handleSearch}>搜索</Button>
                                        <Button onClick={handleReset}>重置</Button>
                                    </Space>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </div>
                
                <Space>
                <span>
                  {hasSelected ? `已选择 ${selectedRows.length} 项` : ''}
                </span>
                    添加付款日期：<DatePicker value={fkrq} onChange={(e) => setFkrq(e)}/>
                    <Button type="primary" disabled={!hasSelected || !fkrq}
                            onClick={handleSetFKRQ}>确认添加</Button>
                </Space>
                <Table
                    dataSource={data}
                    rowKey={"id"}
                    pagination={tableParams.pagination}
                    // size={"small"}
                    onChange={handleTableChange}

                    rowSelection={{
                        type: 'checkbox',
                        ...rowSelection,
                    }}
                    scroll={{
                        x: 700,
                        y: 600,
                    }}
                >
                    <Column title="编号" dataIndex="id" key="id" width={100}/>
                    {/*自动编号*/}
                    <Column title="创建日期" dataIndex="cjsj" key="cjsj" width={130}
                            render={(text) => {
                                if (text) {
                                    return moment(text).format('YYYY-MM-DD');
                                }
                                return text;
                            }}
                    />
                    <Column title="付款日期" dataIndex="fkrq" key="fkrq" width={130}
                            render={(text) => {
                                if (isMoment(text)) {
                                    return moment(text).format('YYYY-MM-DD');
                                }
                                return text;
                            }}
                    />
                    <Column title="笔数" dataIndex="bishu" key="bishu" width={130}
                            render={(text) => {
                                return text + '笔';
                            }}
                    />
                    <Column title="金额" dataIndex="hjje" key="hjje" width={130}
                            render={(text) => {
                                return text + '元';
                            }}
                    />
                    <Column title="户号" dataIndex="huhao" key="huhao" width={130}/>
                    <Column title="账号" dataIndex="zhanghao" key="zhanghao" width={130}/>
                    <Column title="开户行" dataIndex="kaihuhang" key="kaihuhang" width={130}/>
                    <Column title="操作" key="action" width={100} fixed="right"
                            render={(text, record) => {
                                return (
                                    <Space>
                                        <a onClick={() => {
                                            setDetailModal(record.id);
                                        }}>详情</a>
                                        <Popconfirm title="确认删除吗？" onConfirm={() => {
                                            postRemove(record.id).then((res) => {
                                                if (res.code === 0) {
                                                    message.success('删除成功');
                                                    fetchData();
                                                }
                                            }).catch((err) => {
                                                message.error(err.message);
                                            })
                                        }}>
                                            <a>删除</a>
                                        </Popconfirm>
                                    </Space>
                                )
                            }}
                    />
                </Table>
            </Box>

            {detailModal && <ZcfkdEditModal
                id={detailModal}
                onCancel={() => {
                    setDetailModal(null);
                }}
                onOk={() => {
                    setDetailModal(null);
                }}
            />}
        </PageContent>
    )
}

export default Zcsj;
